module.exports = __webpack_public_path__ + "h5/img/f5.872b2bcb.jpg";